// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1C9id","title":"title-1zpbE","description":"description-qdYlH"};